<section class="admin-users">

  <div class="admin-users__toolbar">
    <button type="button" class="btn btn--primary btn--sm" data-id="btn-new-accommodation">
      <i class="icon icon--plus"></i> <%= _lcs( 'Neue Unterkunft anlegen' ) %>
    </button>
  </div>

  <!-- Grid (or loading / empty / error message) is rendered here by AccommodationList.js -->
  <div class="admin-users__state" data-id="accommodations-state"></div>

  <!-- Create / edit modal (web component) -->
  <accommodation-form data-id="acc-form"></accommodation-form>

  <!-- Read-only details modal (web component) -->
  <accommodation-detail data-id="acc-detail"></accommodation-detail>

</section>
